import { ChangeDetectionStrategy, ChangeDetectorRef, Component, inject, Input, OnInit } from '@angular/core'
import { takeUntil } from 'rxjs/operators'

import { AuthService } from '../../../services/auth.service'
import { DestroyService } from '../../../services/destroy.service'
import { InfoPopupService } from '../../../services/info-popup.service'
import { LikeInfoApiService } from '../../../services/like-info/like-info-api.service'
import { LikeInfo } from '../../../services/like-info/like-info.types'

@Component({
  selector: 'bmcore-like-btn',
  templateUrl: './bmcore-like-btn.component.html',
  styleUrls: ['./bmcore-like-btn.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class BmcoreLikeBtnComponent implements OnInit {
  private readonly authService = inject(AuthService)
  private readonly destroy$ = inject(DestroyService)
  private readonly infoPopupService = inject(InfoPopupService)
  private readonly likeInfoApiService = inject(LikeInfoApiService)
  private readonly cdr = inject(ChangeDetectorRef)

  @Input() beatId: number

  @Input() showLikesCount = false

  @Input()
  set likeStatus(actualLikeStatus: boolean) {
    this.likeInfo = { ...this.likeInfo, userLike: actualLikeStatus }
  }

  @Input()
  set likesCount(actualLikesCount: number) {
    this.likeInfo = { ...this.likeInfo, likesCount: actualLikesCount }
  }

  @Input() iconSize = 24

  likeInfo: LikeInfo

  ngOnInit(): void {
    this.likeInfoApiService.changeTrackLikeInfoEvent.pipe(takeUntil(this.destroy$)).subscribe(payload => {
      if (payload && payload.beatId === this.beatId) {
        const newLikeStatus = !this.likeInfo?.userLike
        const newLikesCount = newLikeStatus
          ? (this.likeInfo?.likesCount ?? 0) + 1
          : (this.likeInfo?.likesCount ?? 0) - 1
        this.likeInfo = { ...this.likeInfo, userLike: newLikeStatus, likesCount: newLikesCount }
        this.cdr.markForCheck()
      }
    })
  }

  handleToggleBeatLikeStatus(e: MouseEvent) {
    e.stopPropagation()
    if (this.authService.isAuthenticated) {
      const newLikeStatus = !this.likeInfo.userLike
      this.likeInfoApiService.updateBeatLikeStatus({ beatId: this.beatId, likeStatus: newLikeStatus })
    } else {
      this.infoPopupService.notify('“Change Like status”')
    }
  }
}
